/*
  const uppercase = (str: string) => str[0].toUpperCase() + str.slice(1);

  const getClassStrings = (color: string, suffix: string | string[] = []) =>
    Array.from({ length: 12 }, (_, i) =>
      ["bg", color, ...[suffix].flat(), i + 1].join("-")
    );

  function generateScales(colors: string[]) {
    return colors.reduce(
      (acc, color) => ({
        ...acc,
        [uppercase(color)]: {
          [color]: getClassStrings(color),
          [`${color}A`]: getClassStrings(color, "a"),
          [`${color}Dark`]: getClassStrings(color, "dark"),
          [`${color}DarkA`]: getClassStrings(color, ["dark", "a"]),
        },
      }),
      {}
    );
  }

  export const Colors = generateScales(["tomato", "red", "crimson", "pink", "plum", "purple", "violet", "indigo", "blue", "cyan", "teal", "green", "grass", "orange", "brown"]);
  export const BrightColors = generateScales(["sky", "mint", "lime", "yellow", "amber"])
  export const Grays = generateScales(["gray", "mauve", "slate", "sage", "olive", "sand"])
  export const Metals = generateScales(["gold", "bronze"])
  export const Overlays = {
    blackA: getClassStrings("black", "a"),
    whiteA: getClassStrings("white", "a"),
  };
*/

export const Colors = {
  Tomato: {
    tomato: [
      "bg-tomato-1",
      "bg-tomato-2",
      "bg-tomato-3",
      "bg-tomato-4",
      "bg-tomato-5",
      "bg-tomato-6",
      "bg-tomato-7",
      "bg-tomato-8",
      "bg-tomato-9",
      "bg-tomato-10",
      "bg-tomato-11",
      "bg-tomato-12",
    ],
    tomatoA: [
      "bg-tomato-a-1",
      "bg-tomato-a-2",
      "bg-tomato-a-3",
      "bg-tomato-a-4",
      "bg-tomato-a-5",
      "bg-tomato-a-6",
      "bg-tomato-a-7",
      "bg-tomato-a-8",
      "bg-tomato-a-9",
      "bg-tomato-a-10",
      "bg-tomato-a-11",
      "bg-tomato-a-12",
    ],
    tomatoDark: [
      "bg-tomato-dark-1",
      "bg-tomato-dark-2",
      "bg-tomato-dark-3",
      "bg-tomato-dark-4",
      "bg-tomato-dark-5",
      "bg-tomato-dark-6",
      "bg-tomato-dark-7",
      "bg-tomato-dark-8",
      "bg-tomato-dark-9",
      "bg-tomato-dark-10",
      "bg-tomato-dark-11",
      "bg-tomato-dark-12",
    ],
    tomatoDarkA: [
      "bg-tomato-dark-a-1",
      "bg-tomato-dark-a-2",
      "bg-tomato-dark-a-3",
      "bg-tomato-dark-a-4",
      "bg-tomato-dark-a-5",
      "bg-tomato-dark-a-6",
      "bg-tomato-dark-a-7",
      "bg-tomato-dark-a-8",
      "bg-tomato-dark-a-9",
      "bg-tomato-dark-a-10",
      "bg-tomato-dark-a-11",
      "bg-tomato-dark-a-12",
    ],
  },
  Red: {
    red: [
      "bg-red-1",
      "bg-red-2",
      "bg-red-3",
      "bg-red-4",
      "bg-red-5",
      "bg-red-6",
      "bg-red-7",
      "bg-red-8",
      "bg-red-9",
      "bg-red-10",
      "bg-red-11",
      "bg-red-12",
    ],
    redA: [
      "bg-red-a-1",
      "bg-red-a-2",
      "bg-red-a-3",
      "bg-red-a-4",
      "bg-red-a-5",
      "bg-red-a-6",
      "bg-red-a-7",
      "bg-red-a-8",
      "bg-red-a-9",
      "bg-red-a-10",
      "bg-red-a-11",
      "bg-red-a-12",
    ],
    redDark: [
      "bg-red-dark-1",
      "bg-red-dark-2",
      "bg-red-dark-3",
      "bg-red-dark-4",
      "bg-red-dark-5",
      "bg-red-dark-6",
      "bg-red-dark-7",
      "bg-red-dark-8",
      "bg-red-dark-9",
      "bg-red-dark-10",
      "bg-red-dark-11",
      "bg-red-dark-12",
    ],
    redDarkA: [
      "bg-red-dark-a-1",
      "bg-red-dark-a-2",
      "bg-red-dark-a-3",
      "bg-red-dark-a-4",
      "bg-red-dark-a-5",
      "bg-red-dark-a-6",
      "bg-red-dark-a-7",
      "bg-red-dark-a-8",
      "bg-red-dark-a-9",
      "bg-red-dark-a-10",
      "bg-red-dark-a-11",
      "bg-red-dark-a-12",
    ],
  },
  Crimson: {
    crimson: [
      "bg-crimson-1",
      "bg-crimson-2",
      "bg-crimson-3",
      "bg-crimson-4",
      "bg-crimson-5",
      "bg-crimson-6",
      "bg-crimson-7",
      "bg-crimson-8",
      "bg-crimson-9",
      "bg-crimson-10",
      "bg-crimson-11",
      "bg-crimson-12",
    ],
    crimsonA: [
      "bg-crimson-a-1",
      "bg-crimson-a-2",
      "bg-crimson-a-3",
      "bg-crimson-a-4",
      "bg-crimson-a-5",
      "bg-crimson-a-6",
      "bg-crimson-a-7",
      "bg-crimson-a-8",
      "bg-crimson-a-9",
      "bg-crimson-a-10",
      "bg-crimson-a-11",
      "bg-crimson-a-12",
    ],
    crimsonDark: [
      "bg-crimson-dark-1",
      "bg-crimson-dark-2",
      "bg-crimson-dark-3",
      "bg-crimson-dark-4",
      "bg-crimson-dark-5",
      "bg-crimson-dark-6",
      "bg-crimson-dark-7",
      "bg-crimson-dark-8",
      "bg-crimson-dark-9",
      "bg-crimson-dark-10",
      "bg-crimson-dark-11",
      "bg-crimson-dark-12",
    ],
    crimsonDarkA: [
      "bg-crimson-dark-a-1",
      "bg-crimson-dark-a-2",
      "bg-crimson-dark-a-3",
      "bg-crimson-dark-a-4",
      "bg-crimson-dark-a-5",
      "bg-crimson-dark-a-6",
      "bg-crimson-dark-a-7",
      "bg-crimson-dark-a-8",
      "bg-crimson-dark-a-9",
      "bg-crimson-dark-a-10",
      "bg-crimson-dark-a-11",
      "bg-crimson-dark-a-12",
    ],
  },
  Pink: {
    pink: [
      "bg-pink-1",
      "bg-pink-2",
      "bg-pink-3",
      "bg-pink-4",
      "bg-pink-5",
      "bg-pink-6",
      "bg-pink-7",
      "bg-pink-8",
      "bg-pink-9",
      "bg-pink-10",
      "bg-pink-11",
      "bg-pink-12",
    ],
    pinkA: [
      "bg-pink-a-1",
      "bg-pink-a-2",
      "bg-pink-a-3",
      "bg-pink-a-4",
      "bg-pink-a-5",
      "bg-pink-a-6",
      "bg-pink-a-7",
      "bg-pink-a-8",
      "bg-pink-a-9",
      "bg-pink-a-10",
      "bg-pink-a-11",
      "bg-pink-a-12",
    ],
    pinkDark: [
      "bg-pink-dark-1",
      "bg-pink-dark-2",
      "bg-pink-dark-3",
      "bg-pink-dark-4",
      "bg-pink-dark-5",
      "bg-pink-dark-6",
      "bg-pink-dark-7",
      "bg-pink-dark-8",
      "bg-pink-dark-9",
      "bg-pink-dark-10",
      "bg-pink-dark-11",
      "bg-pink-dark-12",
    ],
    pinkDarkA: [
      "bg-pink-dark-a-1",
      "bg-pink-dark-a-2",
      "bg-pink-dark-a-3",
      "bg-pink-dark-a-4",
      "bg-pink-dark-a-5",
      "bg-pink-dark-a-6",
      "bg-pink-dark-a-7",
      "bg-pink-dark-a-8",
      "bg-pink-dark-a-9",
      "bg-pink-dark-a-10",
      "bg-pink-dark-a-11",
      "bg-pink-dark-a-12",
    ],
  },
  Plum: {
    plum: [
      "bg-plum-1",
      "bg-plum-2",
      "bg-plum-3",
      "bg-plum-4",
      "bg-plum-5",
      "bg-plum-6",
      "bg-plum-7",
      "bg-plum-8",
      "bg-plum-9",
      "bg-plum-10",
      "bg-plum-11",
      "bg-plum-12",
    ],
    plumA: [
      "bg-plum-a-1",
      "bg-plum-a-2",
      "bg-plum-a-3",
      "bg-plum-a-4",
      "bg-plum-a-5",
      "bg-plum-a-6",
      "bg-plum-a-7",
      "bg-plum-a-8",
      "bg-plum-a-9",
      "bg-plum-a-10",
      "bg-plum-a-11",
      "bg-plum-a-12",
    ],
    plumDark: [
      "bg-plum-dark-1",
      "bg-plum-dark-2",
      "bg-plum-dark-3",
      "bg-plum-dark-4",
      "bg-plum-dark-5",
      "bg-plum-dark-6",
      "bg-plum-dark-7",
      "bg-plum-dark-8",
      "bg-plum-dark-9",
      "bg-plum-dark-10",
      "bg-plum-dark-11",
      "bg-plum-dark-12",
    ],
    plumDarkA: [
      "bg-plum-dark-a-1",
      "bg-plum-dark-a-2",
      "bg-plum-dark-a-3",
      "bg-plum-dark-a-4",
      "bg-plum-dark-a-5",
      "bg-plum-dark-a-6",
      "bg-plum-dark-a-7",
      "bg-plum-dark-a-8",
      "bg-plum-dark-a-9",
      "bg-plum-dark-a-10",
      "bg-plum-dark-a-11",
      "bg-plum-dark-a-12",
    ],
  },
  Purple: {
    purple: [
      "bg-purple-1",
      "bg-purple-2",
      "bg-purple-3",
      "bg-purple-4",
      "bg-purple-5",
      "bg-purple-6",
      "bg-purple-7",
      "bg-purple-8",
      "bg-purple-9",
      "bg-purple-10",
      "bg-purple-11",
      "bg-purple-12",
    ],
    purpleA: [
      "bg-purple-a-1",
      "bg-purple-a-2",
      "bg-purple-a-3",
      "bg-purple-a-4",
      "bg-purple-a-5",
      "bg-purple-a-6",
      "bg-purple-a-7",
      "bg-purple-a-8",
      "bg-purple-a-9",
      "bg-purple-a-10",
      "bg-purple-a-11",
      "bg-purple-a-12",
    ],
    purpleDark: [
      "bg-purple-dark-1",
      "bg-purple-dark-2",
      "bg-purple-dark-3",
      "bg-purple-dark-4",
      "bg-purple-dark-5",
      "bg-purple-dark-6",
      "bg-purple-dark-7",
      "bg-purple-dark-8",
      "bg-purple-dark-9",
      "bg-purple-dark-10",
      "bg-purple-dark-11",
      "bg-purple-dark-12",
    ],
    purpleDarkA: [
      "bg-purple-dark-a-1",
      "bg-purple-dark-a-2",
      "bg-purple-dark-a-3",
      "bg-purple-dark-a-4",
      "bg-purple-dark-a-5",
      "bg-purple-dark-a-6",
      "bg-purple-dark-a-7",
      "bg-purple-dark-a-8",
      "bg-purple-dark-a-9",
      "bg-purple-dark-a-10",
      "bg-purple-dark-a-11",
      "bg-purple-dark-a-12",
    ],
  },
  Violet: {
    violet: [
      "bg-violet-1",
      "bg-violet-2",
      "bg-violet-3",
      "bg-violet-4",
      "bg-violet-5",
      "bg-violet-6",
      "bg-violet-7",
      "bg-violet-8",
      "bg-violet-9",
      "bg-violet-10",
      "bg-violet-11",
      "bg-violet-12",
    ],
    violetA: [
      "bg-violet-a-1",
      "bg-violet-a-2",
      "bg-violet-a-3",
      "bg-violet-a-4",
      "bg-violet-a-5",
      "bg-violet-a-6",
      "bg-violet-a-7",
      "bg-violet-a-8",
      "bg-violet-a-9",
      "bg-violet-a-10",
      "bg-violet-a-11",
      "bg-violet-a-12",
    ],
    violetDark: [
      "bg-violet-dark-1",
      "bg-violet-dark-2",
      "bg-violet-dark-3",
      "bg-violet-dark-4",
      "bg-violet-dark-5",
      "bg-violet-dark-6",
      "bg-violet-dark-7",
      "bg-violet-dark-8",
      "bg-violet-dark-9",
      "bg-violet-dark-10",
      "bg-violet-dark-11",
      "bg-violet-dark-12",
    ],
    violetDarkA: [
      "bg-violet-dark-a-1",
      "bg-violet-dark-a-2",
      "bg-violet-dark-a-3",
      "bg-violet-dark-a-4",
      "bg-violet-dark-a-5",
      "bg-violet-dark-a-6",
      "bg-violet-dark-a-7",
      "bg-violet-dark-a-8",
      "bg-violet-dark-a-9",
      "bg-violet-dark-a-10",
      "bg-violet-dark-a-11",
      "bg-violet-dark-a-12",
    ],
  },
  Indigo: {
    indigo: [
      "bg-indigo-1",
      "bg-indigo-2",
      "bg-indigo-3",
      "bg-indigo-4",
      "bg-indigo-5",
      "bg-indigo-6",
      "bg-indigo-7",
      "bg-indigo-8",
      "bg-indigo-9",
      "bg-indigo-10",
      "bg-indigo-11",
      "bg-indigo-12",
    ],
    indigoA: [
      "bg-indigo-a-1",
      "bg-indigo-a-2",
      "bg-indigo-a-3",
      "bg-indigo-a-4",
      "bg-indigo-a-5",
      "bg-indigo-a-6",
      "bg-indigo-a-7",
      "bg-indigo-a-8",
      "bg-indigo-a-9",
      "bg-indigo-a-10",
      "bg-indigo-a-11",
      "bg-indigo-a-12",
    ],
    indigoDark: [
      "bg-indigo-dark-1",
      "bg-indigo-dark-2",
      "bg-indigo-dark-3",
      "bg-indigo-dark-4",
      "bg-indigo-dark-5",
      "bg-indigo-dark-6",
      "bg-indigo-dark-7",
      "bg-indigo-dark-8",
      "bg-indigo-dark-9",
      "bg-indigo-dark-10",
      "bg-indigo-dark-11",
      "bg-indigo-dark-12",
    ],
    indigoDarkA: [
      "bg-indigo-dark-a-1",
      "bg-indigo-dark-a-2",
      "bg-indigo-dark-a-3",
      "bg-indigo-dark-a-4",
      "bg-indigo-dark-a-5",
      "bg-indigo-dark-a-6",
      "bg-indigo-dark-a-7",
      "bg-indigo-dark-a-8",
      "bg-indigo-dark-a-9",
      "bg-indigo-dark-a-10",
      "bg-indigo-dark-a-11",
      "bg-indigo-dark-a-12",
    ],
  },
  Blue: {
    blue: [
      "bg-blue-1",
      "bg-blue-2",
      "bg-blue-3",
      "bg-blue-4",
      "bg-blue-5",
      "bg-blue-6",
      "bg-blue-7",
      "bg-blue-8",
      "bg-blue-9",
      "bg-blue-10",
      "bg-blue-11",
      "bg-blue-12",
    ],
    blueA: [
      "bg-blue-a-1",
      "bg-blue-a-2",
      "bg-blue-a-3",
      "bg-blue-a-4",
      "bg-blue-a-5",
      "bg-blue-a-6",
      "bg-blue-a-7",
      "bg-blue-a-8",
      "bg-blue-a-9",
      "bg-blue-a-10",
      "bg-blue-a-11",
      "bg-blue-a-12",
    ],
    blueDark: [
      "bg-blue-dark-1",
      "bg-blue-dark-2",
      "bg-blue-dark-3",
      "bg-blue-dark-4",
      "bg-blue-dark-5",
      "bg-blue-dark-6",
      "bg-blue-dark-7",
      "bg-blue-dark-8",
      "bg-blue-dark-9",
      "bg-blue-dark-10",
      "bg-blue-dark-11",
      "bg-blue-dark-12",
    ],
    blueDarkA: [
      "bg-blue-dark-a-1",
      "bg-blue-dark-a-2",
      "bg-blue-dark-a-3",
      "bg-blue-dark-a-4",
      "bg-blue-dark-a-5",
      "bg-blue-dark-a-6",
      "bg-blue-dark-a-7",
      "bg-blue-dark-a-8",
      "bg-blue-dark-a-9",
      "bg-blue-dark-a-10",
      "bg-blue-dark-a-11",
      "bg-blue-dark-a-12",
    ],
  },
  Cyan: {
    cyan: [
      "bg-cyan-1",
      "bg-cyan-2",
      "bg-cyan-3",
      "bg-cyan-4",
      "bg-cyan-5",
      "bg-cyan-6",
      "bg-cyan-7",
      "bg-cyan-8",
      "bg-cyan-9",
      "bg-cyan-10",
      "bg-cyan-11",
      "bg-cyan-12",
    ],
    cyanA: [
      "bg-cyan-a-1",
      "bg-cyan-a-2",
      "bg-cyan-a-3",
      "bg-cyan-a-4",
      "bg-cyan-a-5",
      "bg-cyan-a-6",
      "bg-cyan-a-7",
      "bg-cyan-a-8",
      "bg-cyan-a-9",
      "bg-cyan-a-10",
      "bg-cyan-a-11",
      "bg-cyan-a-12",
    ],
    cyanDark: [
      "bg-cyan-dark-1",
      "bg-cyan-dark-2",
      "bg-cyan-dark-3",
      "bg-cyan-dark-4",
      "bg-cyan-dark-5",
      "bg-cyan-dark-6",
      "bg-cyan-dark-7",
      "bg-cyan-dark-8",
      "bg-cyan-dark-9",
      "bg-cyan-dark-10",
      "bg-cyan-dark-11",
      "bg-cyan-dark-12",
    ],
    cyanDarkA: [
      "bg-cyan-dark-a-1",
      "bg-cyan-dark-a-2",
      "bg-cyan-dark-a-3",
      "bg-cyan-dark-a-4",
      "bg-cyan-dark-a-5",
      "bg-cyan-dark-a-6",
      "bg-cyan-dark-a-7",
      "bg-cyan-dark-a-8",
      "bg-cyan-dark-a-9",
      "bg-cyan-dark-a-10",
      "bg-cyan-dark-a-11",
      "bg-cyan-dark-a-12",
    ],
  },
  Teal: {
    teal: [
      "bg-teal-1",
      "bg-teal-2",
      "bg-teal-3",
      "bg-teal-4",
      "bg-teal-5",
      "bg-teal-6",
      "bg-teal-7",
      "bg-teal-8",
      "bg-teal-9",
      "bg-teal-10",
      "bg-teal-11",
      "bg-teal-12",
    ],
    tealA: [
      "bg-teal-a-1",
      "bg-teal-a-2",
      "bg-teal-a-3",
      "bg-teal-a-4",
      "bg-teal-a-5",
      "bg-teal-a-6",
      "bg-teal-a-7",
      "bg-teal-a-8",
      "bg-teal-a-9",
      "bg-teal-a-10",
      "bg-teal-a-11",
      "bg-teal-a-12",
    ],
    tealDark: [
      "bg-teal-dark-1",
      "bg-teal-dark-2",
      "bg-teal-dark-3",
      "bg-teal-dark-4",
      "bg-teal-dark-5",
      "bg-teal-dark-6",
      "bg-teal-dark-7",
      "bg-teal-dark-8",
      "bg-teal-dark-9",
      "bg-teal-dark-10",
      "bg-teal-dark-11",
      "bg-teal-dark-12",
    ],
    tealDarkA: [
      "bg-teal-dark-a-1",
      "bg-teal-dark-a-2",
      "bg-teal-dark-a-3",
      "bg-teal-dark-a-4",
      "bg-teal-dark-a-5",
      "bg-teal-dark-a-6",
      "bg-teal-dark-a-7",
      "bg-teal-dark-a-8",
      "bg-teal-dark-a-9",
      "bg-teal-dark-a-10",
      "bg-teal-dark-a-11",
      "bg-teal-dark-a-12",
    ],
  },
  Green: {
    green: [
      "bg-green-1",
      "bg-green-2",
      "bg-green-3",
      "bg-green-4",
      "bg-green-5",
      "bg-green-6",
      "bg-green-7",
      "bg-green-8",
      "bg-green-9",
      "bg-green-10",
      "bg-green-11",
      "bg-green-12",
    ],
    greenA: [
      "bg-green-a-1",
      "bg-green-a-2",
      "bg-green-a-3",
      "bg-green-a-4",
      "bg-green-a-5",
      "bg-green-a-6",
      "bg-green-a-7",
      "bg-green-a-8",
      "bg-green-a-9",
      "bg-green-a-10",
      "bg-green-a-11",
      "bg-green-a-12",
    ],
    greenDark: [
      "bg-green-dark-1",
      "bg-green-dark-2",
      "bg-green-dark-3",
      "bg-green-dark-4",
      "bg-green-dark-5",
      "bg-green-dark-6",
      "bg-green-dark-7",
      "bg-green-dark-8",
      "bg-green-dark-9",
      "bg-green-dark-10",
      "bg-green-dark-11",
      "bg-green-dark-12",
    ],
    greenDarkA: [
      "bg-green-dark-a-1",
      "bg-green-dark-a-2",
      "bg-green-dark-a-3",
      "bg-green-dark-a-4",
      "bg-green-dark-a-5",
      "bg-green-dark-a-6",
      "bg-green-dark-a-7",
      "bg-green-dark-a-8",
      "bg-green-dark-a-9",
      "bg-green-dark-a-10",
      "bg-green-dark-a-11",
      "bg-green-dark-a-12",
    ],
  },
  Grass: {
    grass: [
      "bg-grass-1",
      "bg-grass-2",
      "bg-grass-3",
      "bg-grass-4",
      "bg-grass-5",
      "bg-grass-6",
      "bg-grass-7",
      "bg-grass-8",
      "bg-grass-9",
      "bg-grass-10",
      "bg-grass-11",
      "bg-grass-12",
    ],
    grassA: [
      "bg-grass-a-1",
      "bg-grass-a-2",
      "bg-grass-a-3",
      "bg-grass-a-4",
      "bg-grass-a-5",
      "bg-grass-a-6",
      "bg-grass-a-7",
      "bg-grass-a-8",
      "bg-grass-a-9",
      "bg-grass-a-10",
      "bg-grass-a-11",
      "bg-grass-a-12",
    ],
    grassDark: [
      "bg-grass-dark-1",
      "bg-grass-dark-2",
      "bg-grass-dark-3",
      "bg-grass-dark-4",
      "bg-grass-dark-5",
      "bg-grass-dark-6",
      "bg-grass-dark-7",
      "bg-grass-dark-8",
      "bg-grass-dark-9",
      "bg-grass-dark-10",
      "bg-grass-dark-11",
      "bg-grass-dark-12",
    ],
    grassDarkA: [
      "bg-grass-dark-a-1",
      "bg-grass-dark-a-2",
      "bg-grass-dark-a-3",
      "bg-grass-dark-a-4",
      "bg-grass-dark-a-5",
      "bg-grass-dark-a-6",
      "bg-grass-dark-a-7",
      "bg-grass-dark-a-8",
      "bg-grass-dark-a-9",
      "bg-grass-dark-a-10",
      "bg-grass-dark-a-11",
      "bg-grass-dark-a-12",
    ],
  },
  Orange: {
    orange: [
      "bg-orange-1",
      "bg-orange-2",
      "bg-orange-3",
      "bg-orange-4",
      "bg-orange-5",
      "bg-orange-6",
      "bg-orange-7",
      "bg-orange-8",
      "bg-orange-9",
      "bg-orange-10",
      "bg-orange-11",
      "bg-orange-12",
    ],
    orangeA: [
      "bg-orange-a-1",
      "bg-orange-a-2",
      "bg-orange-a-3",
      "bg-orange-a-4",
      "bg-orange-a-5",
      "bg-orange-a-6",
      "bg-orange-a-7",
      "bg-orange-a-8",
      "bg-orange-a-9",
      "bg-orange-a-10",
      "bg-orange-a-11",
      "bg-orange-a-12",
    ],
    orangeDark: [
      "bg-orange-dark-1",
      "bg-orange-dark-2",
      "bg-orange-dark-3",
      "bg-orange-dark-4",
      "bg-orange-dark-5",
      "bg-orange-dark-6",
      "bg-orange-dark-7",
      "bg-orange-dark-8",
      "bg-orange-dark-9",
      "bg-orange-dark-10",
      "bg-orange-dark-11",
      "bg-orange-dark-12",
    ],
    orangeDarkA: [
      "bg-orange-dark-a-1",
      "bg-orange-dark-a-2",
      "bg-orange-dark-a-3",
      "bg-orange-dark-a-4",
      "bg-orange-dark-a-5",
      "bg-orange-dark-a-6",
      "bg-orange-dark-a-7",
      "bg-orange-dark-a-8",
      "bg-orange-dark-a-9",
      "bg-orange-dark-a-10",
      "bg-orange-dark-a-11",
      "bg-orange-dark-a-12",
    ],
  },
  Brown: {
    brown: [
      "bg-brown-1",
      "bg-brown-2",
      "bg-brown-3",
      "bg-brown-4",
      "bg-brown-5",
      "bg-brown-6",
      "bg-brown-7",
      "bg-brown-8",
      "bg-brown-9",
      "bg-brown-10",
      "bg-brown-11",
      "bg-brown-12",
    ],
    brownA: [
      "bg-brown-a-1",
      "bg-brown-a-2",
      "bg-brown-a-3",
      "bg-brown-a-4",
      "bg-brown-a-5",
      "bg-brown-a-6",
      "bg-brown-a-7",
      "bg-brown-a-8",
      "bg-brown-a-9",
      "bg-brown-a-10",
      "bg-brown-a-11",
      "bg-brown-a-12",
    ],
    brownDark: [
      "bg-brown-dark-1",
      "bg-brown-dark-2",
      "bg-brown-dark-3",
      "bg-brown-dark-4",
      "bg-brown-dark-5",
      "bg-brown-dark-6",
      "bg-brown-dark-7",
      "bg-brown-dark-8",
      "bg-brown-dark-9",
      "bg-brown-dark-10",
      "bg-brown-dark-11",
      "bg-brown-dark-12",
    ],
    brownDarkA: [
      "bg-brown-dark-a-1",
      "bg-brown-dark-a-2",
      "bg-brown-dark-a-3",
      "bg-brown-dark-a-4",
      "bg-brown-dark-a-5",
      "bg-brown-dark-a-6",
      "bg-brown-dark-a-7",
      "bg-brown-dark-a-8",
      "bg-brown-dark-a-9",
      "bg-brown-dark-a-10",
      "bg-brown-dark-a-11",
      "bg-brown-dark-a-12",
    ],
  },
};

export const BrightColors = {
  Sky: {
    sky: [
      "bg-sky-1",
      "bg-sky-2",
      "bg-sky-3",
      "bg-sky-4",
      "bg-sky-5",
      "bg-sky-6",
      "bg-sky-7",
      "bg-sky-8",
      "bg-sky-9",
      "bg-sky-10",
      "bg-sky-11",
      "bg-sky-12",
    ],
    skyA: [
      "bg-sky-a-1",
      "bg-sky-a-2",
      "bg-sky-a-3",
      "bg-sky-a-4",
      "bg-sky-a-5",
      "bg-sky-a-6",
      "bg-sky-a-7",
      "bg-sky-a-8",
      "bg-sky-a-9",
      "bg-sky-a-10",
      "bg-sky-a-11",
      "bg-sky-a-12",
    ],
    skyDark: [
      "bg-sky-dark-1",
      "bg-sky-dark-2",
      "bg-sky-dark-3",
      "bg-sky-dark-4",
      "bg-sky-dark-5",
      "bg-sky-dark-6",
      "bg-sky-dark-7",
      "bg-sky-dark-8",
      "bg-sky-dark-9",
      "bg-sky-dark-10",
      "bg-sky-dark-11",
      "bg-sky-dark-12",
    ],
    skyDarkA: [
      "bg-sky-dark-a-1",
      "bg-sky-dark-a-2",
      "bg-sky-dark-a-3",
      "bg-sky-dark-a-4",
      "bg-sky-dark-a-5",
      "bg-sky-dark-a-6",
      "bg-sky-dark-a-7",
      "bg-sky-dark-a-8",
      "bg-sky-dark-a-9",
      "bg-sky-dark-a-10",
      "bg-sky-dark-a-11",
      "bg-sky-dark-a-12",
    ],
  },
  Mint: {
    mint: [
      "bg-mint-1",
      "bg-mint-2",
      "bg-mint-3",
      "bg-mint-4",
      "bg-mint-5",
      "bg-mint-6",
      "bg-mint-7",
      "bg-mint-8",
      "bg-mint-9",
      "bg-mint-10",
      "bg-mint-11",
      "bg-mint-12",
    ],
    mintA: [
      "bg-mint-a-1",
      "bg-mint-a-2",
      "bg-mint-a-3",
      "bg-mint-a-4",
      "bg-mint-a-5",
      "bg-mint-a-6",
      "bg-mint-a-7",
      "bg-mint-a-8",
      "bg-mint-a-9",
      "bg-mint-a-10",
      "bg-mint-a-11",
      "bg-mint-a-12",
    ],
    mintDark: [
      "bg-mint-dark-1",
      "bg-mint-dark-2",
      "bg-mint-dark-3",
      "bg-mint-dark-4",
      "bg-mint-dark-5",
      "bg-mint-dark-6",
      "bg-mint-dark-7",
      "bg-mint-dark-8",
      "bg-mint-dark-9",
      "bg-mint-dark-10",
      "bg-mint-dark-11",
      "bg-mint-dark-12",
    ],
    mintDarkA: [
      "bg-mint-dark-a-1",
      "bg-mint-dark-a-2",
      "bg-mint-dark-a-3",
      "bg-mint-dark-a-4",
      "bg-mint-dark-a-5",
      "bg-mint-dark-a-6",
      "bg-mint-dark-a-7",
      "bg-mint-dark-a-8",
      "bg-mint-dark-a-9",
      "bg-mint-dark-a-10",
      "bg-mint-dark-a-11",
      "bg-mint-dark-a-12",
    ],
  },
  Lime: {
    lime: [
      "bg-lime-1",
      "bg-lime-2",
      "bg-lime-3",
      "bg-lime-4",
      "bg-lime-5",
      "bg-lime-6",
      "bg-lime-7",
      "bg-lime-8",
      "bg-lime-9",
      "bg-lime-10",
      "bg-lime-11",
      "bg-lime-12",
    ],
    limeA: [
      "bg-lime-a-1",
      "bg-lime-a-2",
      "bg-lime-a-3",
      "bg-lime-a-4",
      "bg-lime-a-5",
      "bg-lime-a-6",
      "bg-lime-a-7",
      "bg-lime-a-8",
      "bg-lime-a-9",
      "bg-lime-a-10",
      "bg-lime-a-11",
      "bg-lime-a-12",
    ],
    limeDark: [
      "bg-lime-dark-1",
      "bg-lime-dark-2",
      "bg-lime-dark-3",
      "bg-lime-dark-4",
      "bg-lime-dark-5",
      "bg-lime-dark-6",
      "bg-lime-dark-7",
      "bg-lime-dark-8",
      "bg-lime-dark-9",
      "bg-lime-dark-10",
      "bg-lime-dark-11",
      "bg-lime-dark-12",
    ],
    limeDarkA: [
      "bg-lime-dark-a-1",
      "bg-lime-dark-a-2",
      "bg-lime-dark-a-3",
      "bg-lime-dark-a-4",
      "bg-lime-dark-a-5",
      "bg-lime-dark-a-6",
      "bg-lime-dark-a-7",
      "bg-lime-dark-a-8",
      "bg-lime-dark-a-9",
      "bg-lime-dark-a-10",
      "bg-lime-dark-a-11",
      "bg-lime-dark-a-12",
    ],
  },
  Yellow: {
    yellow: [
      "bg-yellow-1",
      "bg-yellow-2",
      "bg-yellow-3",
      "bg-yellow-4",
      "bg-yellow-5",
      "bg-yellow-6",
      "bg-yellow-7",
      "bg-yellow-8",
      "bg-yellow-9",
      "bg-yellow-10",
      "bg-yellow-11",
      "bg-yellow-12",
    ],
    yellowA: [
      "bg-yellow-a-1",
      "bg-yellow-a-2",
      "bg-yellow-a-3",
      "bg-yellow-a-4",
      "bg-yellow-a-5",
      "bg-yellow-a-6",
      "bg-yellow-a-7",
      "bg-yellow-a-8",
      "bg-yellow-a-9",
      "bg-yellow-a-10",
      "bg-yellow-a-11",
      "bg-yellow-a-12",
    ],
    yellowDark: [
      "bg-yellow-dark-1",
      "bg-yellow-dark-2",
      "bg-yellow-dark-3",
      "bg-yellow-dark-4",
      "bg-yellow-dark-5",
      "bg-yellow-dark-6",
      "bg-yellow-dark-7",
      "bg-yellow-dark-8",
      "bg-yellow-dark-9",
      "bg-yellow-dark-10",
      "bg-yellow-dark-11",
      "bg-yellow-dark-12",
    ],
    yellowDarkA: [
      "bg-yellow-dark-a-1",
      "bg-yellow-dark-a-2",
      "bg-yellow-dark-a-3",
      "bg-yellow-dark-a-4",
      "bg-yellow-dark-a-5",
      "bg-yellow-dark-a-6",
      "bg-yellow-dark-a-7",
      "bg-yellow-dark-a-8",
      "bg-yellow-dark-a-9",
      "bg-yellow-dark-a-10",
      "bg-yellow-dark-a-11",
      "bg-yellow-dark-a-12",
    ],
  },
  Amber: {
    amber: [
      "bg-amber-1",
      "bg-amber-2",
      "bg-amber-3",
      "bg-amber-4",
      "bg-amber-5",
      "bg-amber-6",
      "bg-amber-7",
      "bg-amber-8",
      "bg-amber-9",
      "bg-amber-10",
      "bg-amber-11",
      "bg-amber-12",
    ],
    amberA: [
      "bg-amber-a-1",
      "bg-amber-a-2",
      "bg-amber-a-3",
      "bg-amber-a-4",
      "bg-amber-a-5",
      "bg-amber-a-6",
      "bg-amber-a-7",
      "bg-amber-a-8",
      "bg-amber-a-9",
      "bg-amber-a-10",
      "bg-amber-a-11",
      "bg-amber-a-12",
    ],
    amberDark: [
      "bg-amber-dark-1",
      "bg-amber-dark-2",
      "bg-amber-dark-3",
      "bg-amber-dark-4",
      "bg-amber-dark-5",
      "bg-amber-dark-6",
      "bg-amber-dark-7",
      "bg-amber-dark-8",
      "bg-amber-dark-9",
      "bg-amber-dark-10",
      "bg-amber-dark-11",
      "bg-amber-dark-12",
    ],
    amberDarkA: [
      "bg-amber-dark-a-1",
      "bg-amber-dark-a-2",
      "bg-amber-dark-a-3",
      "bg-amber-dark-a-4",
      "bg-amber-dark-a-5",
      "bg-amber-dark-a-6",
      "bg-amber-dark-a-7",
      "bg-amber-dark-a-8",
      "bg-amber-dark-a-9",
      "bg-amber-dark-a-10",
      "bg-amber-dark-a-11",
      "bg-amber-dark-a-12",
    ],
  },
};

export const Grays = {
  Gray: {
    gray: [
      "bg-gray-1",
      "bg-gray-2",
      "bg-gray-3",
      "bg-gray-4",
      "bg-gray-5",
      "bg-gray-6",
      "bg-gray-7",
      "bg-gray-8",
      "bg-gray-9",
      "bg-gray-10",
      "bg-gray-11",
      "bg-gray-12",
    ],
    grayA: [
      "bg-gray-a-1",
      "bg-gray-a-2",
      "bg-gray-a-3",
      "bg-gray-a-4",
      "bg-gray-a-5",
      "bg-gray-a-6",
      "bg-gray-a-7",
      "bg-gray-a-8",
      "bg-gray-a-9",
      "bg-gray-a-10",
      "bg-gray-a-11",
      "bg-gray-a-12",
    ],
    grayDark: [
      "bg-gray-dark-1",
      "bg-gray-dark-2",
      "bg-gray-dark-3",
      "bg-gray-dark-4",
      "bg-gray-dark-5",
      "bg-gray-dark-6",
      "bg-gray-dark-7",
      "bg-gray-dark-8",
      "bg-gray-dark-9",
      "bg-gray-dark-10",
      "bg-gray-dark-11",
      "bg-gray-dark-12",
    ],
    grayDarkA: [
      "bg-gray-dark-a-1",
      "bg-gray-dark-a-2",
      "bg-gray-dark-a-3",
      "bg-gray-dark-a-4",
      "bg-gray-dark-a-5",
      "bg-gray-dark-a-6",
      "bg-gray-dark-a-7",
      "bg-gray-dark-a-8",
      "bg-gray-dark-a-9",
      "bg-gray-dark-a-10",
      "bg-gray-dark-a-11",
      "bg-gray-dark-a-12",
    ],
  },
  Mauve: {
    mauve: [
      "bg-mauve-1",
      "bg-mauve-2",
      "bg-mauve-3",
      "bg-mauve-4",
      "bg-mauve-5",
      "bg-mauve-6",
      "bg-mauve-7",
      "bg-mauve-8",
      "bg-mauve-9",
      "bg-mauve-10",
      "bg-mauve-11",
      "bg-mauve-12",
    ],
    mauveA: [
      "bg-mauve-a-1",
      "bg-mauve-a-2",
      "bg-mauve-a-3",
      "bg-mauve-a-4",
      "bg-mauve-a-5",
      "bg-mauve-a-6",
      "bg-mauve-a-7",
      "bg-mauve-a-8",
      "bg-mauve-a-9",
      "bg-mauve-a-10",
      "bg-mauve-a-11",
      "bg-mauve-a-12",
    ],
    mauveDark: [
      "bg-mauve-dark-1",
      "bg-mauve-dark-2",
      "bg-mauve-dark-3",
      "bg-mauve-dark-4",
      "bg-mauve-dark-5",
      "bg-mauve-dark-6",
      "bg-mauve-dark-7",
      "bg-mauve-dark-8",
      "bg-mauve-dark-9",
      "bg-mauve-dark-10",
      "bg-mauve-dark-11",
      "bg-mauve-dark-12",
    ],
    mauveDarkA: [
      "bg-mauve-dark-a-1",
      "bg-mauve-dark-a-2",
      "bg-mauve-dark-a-3",
      "bg-mauve-dark-a-4",
      "bg-mauve-dark-a-5",
      "bg-mauve-dark-a-6",
      "bg-mauve-dark-a-7",
      "bg-mauve-dark-a-8",
      "bg-mauve-dark-a-9",
      "bg-mauve-dark-a-10",
      "bg-mauve-dark-a-11",
      "bg-mauve-dark-a-12",
    ],
  },
  Slate: {
    slate: [
      "bg-slate-1",
      "bg-slate-2",
      "bg-slate-3",
      "bg-slate-4",
      "bg-slate-5",
      "bg-slate-6",
      "bg-slate-7",
      "bg-slate-8",
      "bg-slate-9",
      "bg-slate-10",
      "bg-slate-11",
      "bg-slate-12",
    ],
    slateA: [
      "bg-slate-a-1",
      "bg-slate-a-2",
      "bg-slate-a-3",
      "bg-slate-a-4",
      "bg-slate-a-5",
      "bg-slate-a-6",
      "bg-slate-a-7",
      "bg-slate-a-8",
      "bg-slate-a-9",
      "bg-slate-a-10",
      "bg-slate-a-11",
      "bg-slate-a-12",
    ],
    slateDark: [
      "bg-slate-dark-1",
      "bg-slate-dark-2",
      "bg-slate-dark-3",
      "bg-slate-dark-4",
      "bg-slate-dark-5",
      "bg-slate-dark-6",
      "bg-slate-dark-7",
      "bg-slate-dark-8",
      "bg-slate-dark-9",
      "bg-slate-dark-10",
      "bg-slate-dark-11",
      "bg-slate-dark-12",
    ],
    slateDarkA: [
      "bg-slate-dark-a-1",
      "bg-slate-dark-a-2",
      "bg-slate-dark-a-3",
      "bg-slate-dark-a-4",
      "bg-slate-dark-a-5",
      "bg-slate-dark-a-6",
      "bg-slate-dark-a-7",
      "bg-slate-dark-a-8",
      "bg-slate-dark-a-9",
      "bg-slate-dark-a-10",
      "bg-slate-dark-a-11",
      "bg-slate-dark-a-12",
    ],
  },
  Sage: {
    sage: [
      "bg-sage-1",
      "bg-sage-2",
      "bg-sage-3",
      "bg-sage-4",
      "bg-sage-5",
      "bg-sage-6",
      "bg-sage-7",
      "bg-sage-8",
      "bg-sage-9",
      "bg-sage-10",
      "bg-sage-11",
      "bg-sage-12",
    ],
    sageA: [
      "bg-sage-a-1",
      "bg-sage-a-2",
      "bg-sage-a-3",
      "bg-sage-a-4",
      "bg-sage-a-5",
      "bg-sage-a-6",
      "bg-sage-a-7",
      "bg-sage-a-8",
      "bg-sage-a-9",
      "bg-sage-a-10",
      "bg-sage-a-11",
      "bg-sage-a-12",
    ],
    sageDark: [
      "bg-sage-dark-1",
      "bg-sage-dark-2",
      "bg-sage-dark-3",
      "bg-sage-dark-4",
      "bg-sage-dark-5",
      "bg-sage-dark-6",
      "bg-sage-dark-7",
      "bg-sage-dark-8",
      "bg-sage-dark-9",
      "bg-sage-dark-10",
      "bg-sage-dark-11",
      "bg-sage-dark-12",
    ],
    sageDarkA: [
      "bg-sage-dark-a-1",
      "bg-sage-dark-a-2",
      "bg-sage-dark-a-3",
      "bg-sage-dark-a-4",
      "bg-sage-dark-a-5",
      "bg-sage-dark-a-6",
      "bg-sage-dark-a-7",
      "bg-sage-dark-a-8",
      "bg-sage-dark-a-9",
      "bg-sage-dark-a-10",
      "bg-sage-dark-a-11",
      "bg-sage-dark-a-12",
    ],
  },
  Olive: {
    olive: [
      "bg-olive-1",
      "bg-olive-2",
      "bg-olive-3",
      "bg-olive-4",
      "bg-olive-5",
      "bg-olive-6",
      "bg-olive-7",
      "bg-olive-8",
      "bg-olive-9",
      "bg-olive-10",
      "bg-olive-11",
      "bg-olive-12",
    ],
    oliveA: [
      "bg-olive-a-1",
      "bg-olive-a-2",
      "bg-olive-a-3",
      "bg-olive-a-4",
      "bg-olive-a-5",
      "bg-olive-a-6",
      "bg-olive-a-7",
      "bg-olive-a-8",
      "bg-olive-a-9",
      "bg-olive-a-10",
      "bg-olive-a-11",
      "bg-olive-a-12",
    ],
    oliveDark: [
      "bg-olive-dark-1",
      "bg-olive-dark-2",
      "bg-olive-dark-3",
      "bg-olive-dark-4",
      "bg-olive-dark-5",
      "bg-olive-dark-6",
      "bg-olive-dark-7",
      "bg-olive-dark-8",
      "bg-olive-dark-9",
      "bg-olive-dark-10",
      "bg-olive-dark-11",
      "bg-olive-dark-12",
    ],
    oliveDarkA: [
      "bg-olive-dark-a-1",
      "bg-olive-dark-a-2",
      "bg-olive-dark-a-3",
      "bg-olive-dark-a-4",
      "bg-olive-dark-a-5",
      "bg-olive-dark-a-6",
      "bg-olive-dark-a-7",
      "bg-olive-dark-a-8",
      "bg-olive-dark-a-9",
      "bg-olive-dark-a-10",
      "bg-olive-dark-a-11",
      "bg-olive-dark-a-12",
    ],
  },
  Sand: {
    sand: [
      "bg-sand-1",
      "bg-sand-2",
      "bg-sand-3",
      "bg-sand-4",
      "bg-sand-5",
      "bg-sand-6",
      "bg-sand-7",
      "bg-sand-8",
      "bg-sand-9",
      "bg-sand-10",
      "bg-sand-11",
      "bg-sand-12",
    ],
    sandA: [
      "bg-sand-a-1",
      "bg-sand-a-2",
      "bg-sand-a-3",
      "bg-sand-a-4",
      "bg-sand-a-5",
      "bg-sand-a-6",
      "bg-sand-a-7",
      "bg-sand-a-8",
      "bg-sand-a-9",
      "bg-sand-a-10",
      "bg-sand-a-11",
      "bg-sand-a-12",
    ],
    sandDark: [
      "bg-sand-dark-1",
      "bg-sand-dark-2",
      "bg-sand-dark-3",
      "bg-sand-dark-4",
      "bg-sand-dark-5",
      "bg-sand-dark-6",
      "bg-sand-dark-7",
      "bg-sand-dark-8",
      "bg-sand-dark-9",
      "bg-sand-dark-10",
      "bg-sand-dark-11",
      "bg-sand-dark-12",
    ],
    sandDarkA: [
      "bg-sand-dark-a-1",
      "bg-sand-dark-a-2",
      "bg-sand-dark-a-3",
      "bg-sand-dark-a-4",
      "bg-sand-dark-a-5",
      "bg-sand-dark-a-6",
      "bg-sand-dark-a-7",
      "bg-sand-dark-a-8",
      "bg-sand-dark-a-9",
      "bg-sand-dark-a-10",
      "bg-sand-dark-a-11",
      "bg-sand-dark-a-12",
    ],
  },
};

export const Metals = {
  Gold: {
    gold: [
      "bg-gold-1",
      "bg-gold-2",
      "bg-gold-3",
      "bg-gold-4",
      "bg-gold-5",
      "bg-gold-6",
      "bg-gold-7",
      "bg-gold-8",
      "bg-gold-9",
      "bg-gold-10",
      "bg-gold-11",
      "bg-gold-12",
    ],
    goldA: [
      "bg-gold-a-1",
      "bg-gold-a-2",
      "bg-gold-a-3",
      "bg-gold-a-4",
      "bg-gold-a-5",
      "bg-gold-a-6",
      "bg-gold-a-7",
      "bg-gold-a-8",
      "bg-gold-a-9",
      "bg-gold-a-10",
      "bg-gold-a-11",
      "bg-gold-a-12",
    ],
    goldDark: [
      "bg-gold-dark-1",
      "bg-gold-dark-2",
      "bg-gold-dark-3",
      "bg-gold-dark-4",
      "bg-gold-dark-5",
      "bg-gold-dark-6",
      "bg-gold-dark-7",
      "bg-gold-dark-8",
      "bg-gold-dark-9",
      "bg-gold-dark-10",
      "bg-gold-dark-11",
      "bg-gold-dark-12",
    ],
    goldDarkA: [
      "bg-gold-dark-a-1",
      "bg-gold-dark-a-2",
      "bg-gold-dark-a-3",
      "bg-gold-dark-a-4",
      "bg-gold-dark-a-5",
      "bg-gold-dark-a-6",
      "bg-gold-dark-a-7",
      "bg-gold-dark-a-8",
      "bg-gold-dark-a-9",
      "bg-gold-dark-a-10",
      "bg-gold-dark-a-11",
      "bg-gold-dark-a-12",
    ],
  },
  Bronze: {
    bronze: [
      "bg-bronze-1",
      "bg-bronze-2",
      "bg-bronze-3",
      "bg-bronze-4",
      "bg-bronze-5",
      "bg-bronze-6",
      "bg-bronze-7",
      "bg-bronze-8",
      "bg-bronze-9",
      "bg-bronze-10",
      "bg-bronze-11",
      "bg-bronze-12",
    ],
    bronzeA: [
      "bg-bronze-a-1",
      "bg-bronze-a-2",
      "bg-bronze-a-3",
      "bg-bronze-a-4",
      "bg-bronze-a-5",
      "bg-bronze-a-6",
      "bg-bronze-a-7",
      "bg-bronze-a-8",
      "bg-bronze-a-9",
      "bg-bronze-a-10",
      "bg-bronze-a-11",
      "bg-bronze-a-12",
    ],
    bronzeDark: [
      "bg-bronze-dark-1",
      "bg-bronze-dark-2",
      "bg-bronze-dark-3",
      "bg-bronze-dark-4",
      "bg-bronze-dark-5",
      "bg-bronze-dark-6",
      "bg-bronze-dark-7",
      "bg-bronze-dark-8",
      "bg-bronze-dark-9",
      "bg-bronze-dark-10",
      "bg-bronze-dark-11",
      "bg-bronze-dark-12",
    ],
    bronzeDarkA: [
      "bg-bronze-dark-a-1",
      "bg-bronze-dark-a-2",
      "bg-bronze-dark-a-3",
      "bg-bronze-dark-a-4",
      "bg-bronze-dark-a-5",
      "bg-bronze-dark-a-6",
      "bg-bronze-dark-a-7",
      "bg-bronze-dark-a-8",
      "bg-bronze-dark-a-9",
      "bg-bronze-dark-a-10",
      "bg-bronze-dark-a-11",
      "bg-bronze-dark-a-12",
    ],
  },
};

export const Overlays = {
  blackA: [
    "bg-black-a-1",
    "bg-black-a-2",
    "bg-black-a-3",
    "bg-black-a-4",
    "bg-black-a-5",
    "bg-black-a-6",
    "bg-black-a-7",
    "bg-black-a-8",
    "bg-black-a-9",
    "bg-black-a-10",
    "bg-black-a-11",
    "bg-black-a-12",
  ],
  whiteA: [
    "bg-white-a-1",
    "bg-white-a-2",
    "bg-white-a-3",
    "bg-white-a-4",
    "bg-white-a-5",
    "bg-white-a-6",
    "bg-white-a-7",
    "bg-white-a-8",
    "bg-white-a-9",
    "bg-white-a-10",
    "bg-white-a-11",
    "bg-white-a-12",
  ],
};
